import type React from "react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

type RenderFn = (container: HTMLElement) => React.ReactNode;

export const MountDebugComponent: React.FC<{
  id: `!${string}`;
  debugKey: string;
  render: RenderFn | React.ReactNode;
}> = ({ id, debugKey, render }) => {
  const [containers, setContainers] = useState<HTMLElement[]>([]);

  useEffect(() => {
    const elements = document.querySelectorAll(`[data-debug="${id}"]`);
    const validContainers: HTMLElement[] = [];

    for (const el of elements) {
      if (el instanceof HTMLElement) {
        validContainers.push(el);
      }
    }
    setContainers(validContainers);
  }, [id]);

  return containers.map((container, index) => (
    <PortalRenderer
      render={render}
      container={container}
      portalKey={`${id}-${debugKey}-${index}`}
      key={`${id}-${debugKey}-${index}`}
    />
  ));
};

function PortalRenderer(props: {
  portalKey: string;
  container: HTMLElement;
  render: RenderFn | React.ReactNode;
}) {
  const node = typeof props.render === "function" ? props.render(props.container) : props.render;
  return createPortal(node, props.container, props.portalKey);
}
